<template>
  <div>
    <Alert alert-type="success mt-3">
      <template #icon>
        <v-icon color="#D4990A" size="40">mdi-success</v-icon>
      </template>
      <template #default>
        <!--        <div class="d-flex flex-row justify-space-between">-->
        <!--          <p class="d-flex align-center">{{isBlocked ? 'Ввод данных заблокирован' : 'Форма доступна для заполнения:' }}</p>-->
        <!--          <v-dialog>-->
        <!--            <template #activator="{on,attrs}">-->
        <!--              <v-btn class="success__v-btn" v-on="on" v-bind="attrs">Блокировки</v-btn>-->
        <!--            </template>-->
        <!--            <template>-->
        <!--              <v-card>-->
        <!--                <v-card-text>-->
        <!--                  <v-row>-->
        <!--                    <v-col cols="9">Блокировка раздела "Места для приема граждан по договорам об оказании платных-->
        <!--                      образовательных услуг (все уровни)":-->
        <!--                      <ul>-->
        <!--                        <li v-for="(item, i ) in canBlock.PAID.messages" :key="i">{{ item }}</li>-->
        <!--                      </ul>-->
        <!--                    </v-col>-->
        <!--                    <v-col>-->
        <!--                      <v-btn-->
        <!--                        :disabled="(canBlock.PAID && !canBlock.PAID.canBlock) || isBlocked.PAID"-->
        <!--                        :loading="loadingBlockEnterData"-->
        <!--                        @click="clickBlockEnterData('PAID')"-->
        <!--                        class="success__v-btn"-->
        <!--                        color="#29A128"-->
        <!--                      >-->
        <!--                        <span style="color:#fff;">{{ isBlocked.PAID ? 'Заблокировано' : 'Заблокировать ввод' }}</span>-->
        <!--                      </v-btn>-->
        <!--                    </v-col>-->
        <!--                  </v-row>-->
        <!--                </v-card-text>-->
        <!--              </v-card>-->
        <!--            </template>-->
        <!--          </v-dialog>-->
        <!--        </div>-->
        <div v-if="orgId === 3557" class="d-flex mt-2 flex-row justify-space-between">
          <p class="d-flex align-center">Печать</p>
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="290px"
            offset-y
            transition="scale-transition">
            <template #activator="{ on, attrs }">
              <v-btn class="success__v-btn" v-on="on" v-bind="attrs">Скачать</v-btn>
            </template>
            <template>
              <v-card>
                <v-card-text>
                  <v-row v-if="!!isBlocked.BSMA">
                    <v-col></v-col>
                    <v-col>
                      <card-prin-document-btn
                        :name="`Приложение 1 Места для приема граждан по всем видам бюджета (бакалавриат, специалитет, магистратура, ассистентура-стажировка)`"
                        :link="`/api/${selectedYear}/report/places/bsm/${orgId}`"
                        :token="token" />
                    </v-col>
                  </v-row>
                  <v-row v-if="!!isBlocked.POSTGRADUATE">
                    <v-col></v-col>
                    <v-col>
                      <card-prin-document-btn
                        :name="'Приложение 2 Места для приема граждан по всем видам бюджета (аспирантура)'"
                        :link="`/api/${selectedYear}/report/places/asp/${orgId}`"
                        :token="token" />
                    </v-col>
                  </v-row>
                  <v-row v-if="!!isBlocked.INTERNSHIP">
                    <v-col></v-col>
                    <v-col>
                      <card-prin-document-btn
                        :name="'Приложение 3 Места для приема граждан по всем видам бюджета (ординатура)'"
                        :link="`/api/${selectedYear}/report/places/ord/${orgId}`"
                        :token="token" />
                    </v-col>
                  </v-row>
                  <v-row v-if="!!isBlocked.PAID">
                    <v-col></v-col>
                    <v-col>
                      <card-prin-document-btn
                        :name="'Приложение 4 Места для приема граждан по договорам об оказании платных образовательных услуг (все уровни)'"
                        :link="`/api/${selectedYear}/report/places/paid/${orgId}`"
                        :token="token" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-menu>
        </div>
        <div
          v-if="
            isBlocked.BSMA ||
            isBlocked.POSTGRADUATE ||
            isBlocked.INTERNSHIP ||
            isBlocked.PAID ||
            orgId === 3557
          "
          class="d-flex flex-row justify-end mb-3">
          <v-btn @click="openScansDialog()" class="white__v-btn mt-2">Загрузка сканов</v-btn>
        </div>
      </template>
    </Alert>
    <scans-dialog v-if="orgId" :org-id="orgId" :token="token" ref="scan-dialog"></scans-dialog>
  </div>
</template>

<script>
  import ScansDialog from '@/components/dialog/scansDialog(old)';
  import Alert from '@/components/UI/Alert';
  // import CardPrinDocumentBtn from "@/components/UI/cardPrinDocumentBtn";
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'Blocks',
    components: { Alert, ScansDialog }, //CardPrinDocumentBtn
    data() {
      return {
        selectedYear: '2024',
        loadingBlockEnterData: false,
        showMenu: false,
      };
    },
    created() {
      if (this.getSelectedYear) this.selectedYear = this.getSelectedYear;
    },
    computed: {
      ...mapGetters({ getSelectedYear: 'selectedYear' }),
      ...mapGetters('keycloak', {
        getUserRoles: 'getUserRoles',
        getUserAccessToken: 'getUserAccessToken',
        getCanBlockInfo: 'getCanBlockInfo',
        getUser: 'getUser',
        getBlock: 'getBlock',
        canBlock: 'canBlock',
      }),
      isAdmin() {
        return !!this.getUserRoles.find((el) => el === 'ADMIN_ROLE');
      },
      isBlocked() {
        if (this.isAdmin) return true;
        return this.getBlock;
      },
      token() {
        return this.getUserAccessToken;
      },
      orgId() {
        if (this.isAdmin) return this.$cookies.get('authOrgID');
        return this.getUser?.orgID;
      },
    },
    methods: {
      ...mapActions('notification', { setNotification: 'setNotification' }),
      ...mapActions('keycloak', {
        setAuthBlock: 'setAuthBlock',
      }),
      openScansDialog() {
        this.$refs['scan-dialog'].openDialog();
      },
      async clickBlockEnterData(type = 'BSMA') {
        this.loadingBlockEnterData = true;
        await this.setAuthBlock(type);
        this.loadingBlockEnterData = false;
      },
    },
  };
</script>

<style scoped></style>
